import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconDownload = props => (
  <SvgIcon {...props} viewBox="0 0 14 17">
    <path d="m14 6h-4v-6h-6v6h-4l7 7 7-7zm-14 9v2h14v-2h-14z" />
  </SvgIcon>
);

export default IconDownload;



// WEBPACK FOOTER //
// ./src/components/icons/IconDownload.js